/**
 * Focus mode — the billing surface without the app chrome.
 *
 * The shell costs a fifth of the window in each direction (240px rail, 56px
 * header, 28px footer, plus gutters and sheet padding). On a till that space
 * is cart lines, so `/billing` drops the chrome and keeps only a slim strip
 * for store context and the way out.
 *
 * Why a mode and not a second window: two windows would be two in-memory
 * LokiJS databases flushing over each other, and — sharing one device id and
 * therefore one slot — would mint duplicate invoice numbers. See db/index.ts
 * and billingEngine.ts:366. One window, one database, one counter.
 *
 * The preference is per-browser and deliberately not synced: it is a screen-
 * size choice, not merchant configuration.
 */
const KEY = 'bigxbook:billing.focus';

/** Routes that render without the shell when focus mode is on. */
export const FOCUS_ROUTES: ReadonlySet<string> = new Set(['/billing']);

/** Defaults to on; only an explicit opt-out turns it off. */
export function readFocusPref(): boolean {
  try {
    return localStorage.getItem(KEY) !== 'false';
  } catch {
    // Private mode / storage blocked — fall back to the default rather than
    // failing the render.
    return true;
  }
}

export function writeFocusPref(on: boolean): void {
  try {
    localStorage.setItem(KEY, String(on));
  } catch {
    /* storage blocked — the choice just won't survive a reload */
  }
}
